<template>
  <div>
    <div id="dashboard-analytics" v-if="false">
      <div class="vx-row" >
        <div class="vx-col w-full lg:w-1/2 mb-base">
          <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
            <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
            <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">
            <feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
            <h1 class="mb-6 text-white">Congratulations {{ $store.getters.userFirstName }},</h1>
            <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">You've started using Self Improvee - an&nbsp;important step in your self development. Keep on!</p>
          </vx-card>
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
          <StatisticsCardLine
            hideChart
            color="success"
            icon="TargetIcon"
            icon-right
            :statistic="insights.goals"
            statisticTitle="<strong>Goals</strong> achieved"
            class="mb-base"
          />
          <StatisticsCardLine
            hideChart
            color="success"
            icon="CheckIcon"
            icon-right
            :statistic="insights.subgoals"
            statisticTitle="<strong>Tasks</strong> completed"
          />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
          <StatisticsCardLine
            hideChart
            color="success"
            icon="CompassIcon"
            icon-right
            :statistic="insights.dreams"
            statisticTitle="<strong>Dreams</strong> fulfilled"
            class="mb-base"
          />
          <StatisticsCardLine
            hideChart
            color="success"
            icon="EditIcon"
            icon-right
            :statistic="insights.stories"
            statisticTitle="<strong>Stories</strong> recorded"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <Header title="Dreams you focus on the most" />
        </div>

        <template v-for="dream in dreamsWithMostFocus">
            <div
              :key="`dream_${dream.id}`"
              class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base"
            >
              <Dream
                v-if="dream"
                :dream="dream"
                :focusMode="true"
                class="dream"
              />
              <StatisticsCardLine
                hideChart
                color="success"
                icon="TargetIcon"
                icon-right
                :statistic="insightsByDream(dream).goalsDone"
                statisticTitle="<strong>Goals</strong> achieved"
                class="mt-2"
              />
            </div>
        </template>
      </div>

    </div>
      <div class="mt-3 text-center mb-base">
        <h1 class="mb-4 mt-3">Not enough data yet</h1>

        <img src="@/assets/images/insights.png" class="mx-auto" style="width:30%" alt="Insights">
        <h4 class="mx-auto mb-4">Work on your goals to unlock personalized insights and analytics.</h4>
        <p class="mx-auto">Help us to help you with useful tips and suggestions.</p>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import Dream from '../Dreams/Dream'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine'

export default {
  components: {
    Dream,
    StatisticsCardLine
  },
  computed: {
    insights () {
      return this.$store.getters.insights
    },
    dreamsWithMostFocus () {
      return _.chain(this.$store.getters.allDreams)
        .sortBy((d) => -(this.insightsByDream(d).goalsDone || 0))
        .take(4)
        .value()
    },
    hasDreams () {
      return this.$store.getters.allDreams.length > 0
    }
  },
  methods: {
    insightsByDream (dream) {
      return this.$store.getters.insightsByDream(dream)
    }
  }
}
</script>
<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }
  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }

  p.emph {
    text-size: 1.3rem
  }
}

/*! rtl:end:ignore */
</style>
